/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    SUBSCRIPTIONS_startingFrom: "starting from {0}€/months",
    SUBSCRIPTIONS_startingFromFree: "Free",
    SUBSCRIPTIONS_recurrenceTitleMonthly: "Monthly cost",
    SUBSCRIPTIONS_recurrenceTitleYearly: "Yearly cost",
    SUBSCRIPTIONS_recurrenceMonthly: "Monthly",
    SUBSCRIPTIONS_recurrenceYearly: "Yearly",
    SUBSCRIPTIONS_recurrenceUnitMonthly: "month",
    SUBSCRIPTIONS_recurrenceUnitYearly: "year",

    SUBSCRIPTIONS_save: "Save {0}%",
    SUBSCRIPTIONS_recurrenceInvoicingMonthly: "Invoiced monthly",
    SUBSCRIPTIONS_recurrenceInvoicingYearly: "Invoiced yearly",
    SUBSCRIPTIONS_cartNote: "This is a message to alert you to timely information ...",
    SUBSCRIPTIONS_validateOffer: "Validate your offer",

    SUBSCRIPTIONS_salesNotice: "Are you unable to compose your offer or is it suited to your " +
        "needs?",

    SUBSCRIPTIONS_contactSales: "Talk to a salesperson",
    SUBSCRIPTIONS_showAllFeatures: "See all features",

    SUBSCRIPTIONS_title: "Subscriptions",
    SUBSCRIPTIONS_label: "subscription",
    SUBSCRIPTIONS_create: "Create a subscription",
    SUBSCRIPTIONS_plural_label: "subscriptions",
    SUBSCRIPTIONS_splashScreenTitle: "You have no subscriptions for the moment being",
    SUBSCRIPTIONS_splashScreenDescription:
        "Consider creating products and visiting the pricing page",

    SUBSCRIPTIONS_columnId: "Id",
    SUBSCRIPTIONS_columnCustomerEmail: "Account email",
    SUBSCRIPTIONS_columnState: "State",
    SUBSCRIPTIONS_filterPlan: "Subscription name",
    SUBSCRIPTIONS_filterPlanPlaceholder: "Filter by subscription name",
    SUBSCRIPTIONS_columnLines: "Subscription plans",
    SUBSCRIPTIONS_columnRecurrence: "Recurrence",
    SUBSCRIPTIONS_columnCreatedAt: "Created at",
    SUBSCRIPTIONS_columnUpdatedAt: "Updated at",
    SUBSCRIPTIONS_columnMonthlyTotal: "Average monthly total",
    SUBSCRIPTIONS_columnYearlyTotal: "Average yearly total",
    SUBSCRIPTIONS_monthlyTotalValue: "{amount} {currency} excl. tax/mo",
    SUBSCRIPTIONS_yearlyTotalValue: "{amount} {currency} excl. tax/yr",

    SUBSCRIPTION_Details: "Subscription details",
    SUBSCRIPTION_keyInfo: "Key info",
    SUBSCRIPTION_companyInfo: "Company info",
    SUBSCRIPTION_contactInfo: "Contact details",
    SUBSCRIPTION_monthlyPriceLabel: "Monthly price",
    SUBSCRIPTION_yearlyPriceLabel: "Yearly price",
    SUBSCRIPTION_firstSubscriptionDate: "First subscription on",
    SUBSCRIPTION_lastUpdatedDate: "Updated on",
    SUBSCRIPTION_recurrenceLabel: "Recurrence",
    SUBSCRIPTION_currentPeriod: "Current period from {0} to {1}",
    SUBSCRIPTION_nextCyclePriceNote:
        "The prices shown are those applied to the next billing cycle.",
    SUBSCRIPTION_HISTORY_link: "Change history",
    SUBSCRIPTION_HISTORY_loading: "Loading history…",
    SUBSCRIPTION_HISTORY_empty: "No change recorded for this subscription.",
    SUBSCRIPTION_HISTORY_quantity: "Quantity",
    SUBSCRIPTION_HISTORY_amount: "Price",
    SUBSCRIPTION_HISTORY_seeMore: "see more",
    SUBSCRIPTION_HISTORY_seeLess: "see less",
    SUBSCRIPTIONAUDIT_missingSubscriptionId: "Missing subscription or customer.",
    SUBSCRIPTION_PRODUCTS_PLANS: "Products and prices",
    SUBSCRIPTION_priceIncluded: "Included",
    SUBSCRIPTION_priceTierFree: "Included up to {limit}",
    SUBSCRIPTION_priceTierFreeNoLimit: "First tier free",
    SUBSCRIPTION_BILLING: "Billing",
    SUBSCRIPTION_QUOTA: "Quota",
    SUBSCRIPTIONS_fieldNote: "Note",
    SUBSCRIPTIONS_fieldCoupon: "Coupon",
    SUBSCRIPTION_functionalities: "Features included in this subscription.",
    SUBSCRIPTIONS_unlimitedQuantity: "Unlimited",

    SUBSCRIPTIONS_statusOffer: "Offer",
    SUBSCRIPTIONS_statusActive: "Active",
    SUBSCRIPTIONS_statusIncomplete: "Incomplete",
    SUBSCRIPTIONS_statusIncompleted_Expired: "Expired",
    SUBSCRIPTIONS_statusPastDue: "Past Due",
    SUBSCRIPTIONS_statusTrial: "Trial",
    SUBSCRIPTIONS_statusTrialBadge: "Trial",
    SUBSCRIPTIONS_statusCanceled: "Canceled",
    SUBSCRIPTIONS_statusUnpaid: "Unpaid",

    SUBSCRIPTION_actionUnsubscribe: "Cancel at the end of the period",
    SUBSCRIPTION_actionCancel: "Cancel subscription immediately",
    SUBSCRIPTION_cancelWarning: "Attention !",
    SUBSCRIPTION_confirmCancellation: "Yes I want to cancel",
    SUBSCRIPTION_cancellationMessage: "You will cancel this customer's subscription.",
    SUBSCRIPTION_cancellationDeadlineMessage:
        "After cancellation, the last billing will stop on the date of {0}",
    SUBSCRIPTION_confirmCancellationMessage: "You are sure ?",

    SUBSCRIPTIONS_current: "Current subscription",

    SUBSCRIPTIONS_incompatiblePlan: "This plan is not compatible with your other selected plans.",

    SUBSCRIPTIONS_recommended: "Recommended",

    SUBSCRIPTION_download: "Download",
    SUBSCRIPTION_paid: "PAID",
    SUBSCRIPTION_open: "WAITING",
    SUBSCRIPTION_void: "CANCELED",
    SUBSCRIPTION_uncollectible: "UNCOLLECTIBLE",

    SUBSCRIPTION_nextPayment: "Next payment on",
    SUBSCRIPTION_cannotEndTrialForSubscription: "This customer does not have a trial subscription",
    SUBSCRIPTION_actionStripeRedirection: "Redirect to the subscription page",
    SUBSCRIPTION_unsubscribeSuccessTitle: "Notification",
    SUBSCRIPTION_unsubscribeSuccessMessage: "Your subscription has been scheduled for cancellation",
    SUBSCRIPTION_actionChangeRecurrence: "Change billing recurrence",
    SUBSCRIPTION_confirmChangeRecurrence: "Confirm change",
    SUBSCRIPTION_recurrenceMonthly: "monthly",
    SUBSCRIPTION_recurrenceYearly: "yearly",
    SUBSCRIPTION_recurrencePhraseMonthly: "monthly billing",
    SUBSCRIPTION_recurrencePhraseYearly: "yearly billing",
    SUBSCRIPTION_changeRecurrenceMessage:
        "This subscription will switch to {0}. The Stripe items will be replaced without \
        cancelling the subscription.",
    SUBSCRIPTION_changeRecurrenceConfirmMessage:
        "Do you confirm the manual switch to {0}?",
    SUBSCRIPTION_changeRecurrenceSuccessTitle: "Notification",
    SUBSCRIPTION_changeRecurrenceSuccessMessage: "The subscription recurrence has been changed",
    SUBSCRIPTIONS_stripeSubscriptionGone:
        "This subscription no longer exists in Stripe (deleted or ended): nothing was changed.",
    SUBSCRIPTIONS_recurrenceChangeRequiresActive:
        "The recurrence can only be changed on an active subscription.",
    SUBSCRIPTIONS_invalidRecurrence: "Invalid recurrence.",
    SUBSCRIPTIONS_unsubscribeConfirm: "Are you sure you want to cancel this subscription? | \
        Are you sure you want to cancel these subscriptions?",
    SUBSCRIPTIONS_recurrentPriceLine: "{subtotal} {currency} / {recurrence}",
    SUBSCRIPTIONS_globalPriceLine: "{subtotal} {currency}",
    SUBSCRIPTIONS_subscribedPlansSubtitle: "{productName} - {planName}",
    SUBSCRIPTIONS_discountActivated:
        `This subscription benefits from a reduction of {discountValue} of {discountDuration}
        starting the {discountDate}`,
    SUBSCRIPTIONS_yearlyDiscountActivated:
        "This subscription benefits from a reduction of {discountValue}",
    SUBSCRIPTIONS_yearlyDiscountExpired:
        "This subscription has benefited from a reduction of {discountValue}",
    SUBSCRIPTIONS_discountExpired:
        `This subscription has benefited from a reduction of {discountValue} of {discountDuration}
        starting the {discountDate}`,

    SUBSCRIPTIONS_migrateAllAction: "Apply prices to customers",
    SUBSCRIPTIONS_migrateAllConfirm:
        `Apply the published prices to all existing customers still on older prices? The new price
        will take effect at the next billing cycle, with no immediate prorated charge.`,
    SUBSCRIPTIONS_migrateAllTitle: "Price migration",
    SUBSCRIPTIONS_migratePlansLabel: "Affected plans",
    SUBSCRIPTIONS_migrateSeeAccounts: "See affected accounts",
    SUBSCRIPTIONS_migrateApplyTo: "Apply to {count} account(s)",
    SUBSCRIPTIONS_migrateBackToPlans: "‹ Back to plans",
    SUBSCRIPTIONS_migrateAccountsHelp:
        "Accounts still on older prices. Amounts excluding tax, per month or per year "
        + "depending on their recurrence. The new price starts at the next billing date. "
        + "Untick the ones to keep on their current price.",
    SUBSCRIPTIONS_migrateAccountsLoading: "Computing amounts…",
    SUBSCRIPTIONS_migrateAccountsEmpty:
        "No account to migrate: all are already on the published prices.",
    SUBSCRIPTIONS_migrateAccountsSearch: "Search a company",
    SUBSCRIPTIONS_migrateAccountsCount: "{selected} / {total} selected",
    SUBSCRIPTIONS_migrateColCustomer: "Company",
    SUBSCRIPTIONS_migrateColPlan: "Plan",
    SUBSCRIPTIONS_migrateColRecurrence: "Recurrence",
    SUBSCRIPTIONS_migrateColNext: "Next billing",
    SUBSCRIPTIONS_migrateColAmount: "Before → after (excl. tax)",
    SUBSCRIPTIONS_migrateAllDone: "{count} subscription(s) migrated to the current prices",
    SUBSCRIPTIONS_migrateAllStarting: "Migrating…",
    SUBSCRIPTIONS_migrateAllProgress:
        "Migrating… {examined}/{total} subscription(s) processed, {migrated} migrated",
    SUBSCRIPTIONMIGRATION_title: "Price migration history",
    SUBSCRIPTIONMIGRATION_loading: "Loading history…",
    SUBSCRIPTIONMIGRATION_empty: "No migration recorded",
    SUBSCRIPTIONMIGRATION_filterAll: "All",
    SUBSCRIPTIONMIGRATION_filterMigrated: "Migrated",
    SUBSCRIPTIONMIGRATION_filterFailed: "Failed",
    SUBSCRIPTIONMIGRATION_filterSkipped: "Skipped",
    SUBSCRIPTIONMIGRATION_filterUpToDate: "Already up to date",
    SUBSCRIPTIONMIGRATION_filterOutOfScope: "Out of scope",
    SUBSCRIPTIONMIGRATION_statusMigrated: "Migrated",
    SUBSCRIPTIONMIGRATION_statusFailed: "Failed",
    SUBSCRIPTIONMIGRATION_statusSkipped: "Skipped",
    SUBSCRIPTIONMIGRATION_statusUpToDate: "Already up to date",
    SUBSCRIPTIONMIGRATION_statusOutOfScope: "Out of scope",
    SUBSCRIPTIONMIGRATION_explainMigrated: "This subscription was on old prices. The migration "
        + "re-pinned it onto the plan's current prices and re-billed it. The detail below shows "
        + "the before / after (global prices are not concerned).",
    SUBSCRIPTIONMIGRATION_explainUpToDate: "This subscription was already on the plan's current "
        + "prices. Nothing to migrate, no re-billing (global prices are not concerned).",
    SUBSCRIPTIONMIGRATION_explainSkipped: "Subscription cannot be migrated: its Stripe "
        + "counterpart is canceled or gone. No retry can fix it.",
    SUBSCRIPTIONMIGRATION_explainFailed: "The migration failed on a retryable error. The "
        + "Retry button replays the migration.",
    SUBSCRIPTIONMIGRATION_explainOutOfScope: "Subscription not concerned by this run: not "
        + "active, or no line on the selected plans.",
    SUBSCRIPTIONMIGRATION_colDate: "Date",
    SUBSCRIPTIONMIGRATION_colSubscription: "Subscription",
    SUBSCRIPTIONMIGRATION_colCustomer: "Customer",
    SUBSCRIPTIONMIGRATION_colStatus: "Status",
    SUBSCRIPTIONMIGRATION_colReason: "Reason",
    SUBSCRIPTIONMIGRATION_count: "{total} row(s)",
    SUBSCRIPTIONMIGRATION_previous: "Previous",
    SUBSCRIPTIONMIGRATION_next: "Next",
    SUBSCRIPTIONMIGRATION_pageOf: "Page {page} / {pages}",
    SUBSCRIPTIONMIGRATION_tab: "Migration",
    SUBSCRIPTIONMIGRATION_colAction: "Action",
    SUBSCRIPTIONMIGRATION_showDetail: "Detail",
    SUBSCRIPTIONMIGRATION_hideDetail: "Hide",
    SUBSCRIPTIONMIGRATION_retry: "Retry",
    SUBSCRIPTIONMIGRATION_retrying: "Retrying…",
    SUBSCRIPTIONMIGRATION_retryTitle: "Migration retry",
    SUBSCRIPTIONMIGRATION_retryDone: "Subscription migrated to the current prices",
    SUBSCRIPTIONMIGRATION_retryFailed: "The migration failed again",
    SUBSCRIPTIONMIGRATION_detailRecurrence: "Recurrence:",
    SUBSCRIPTIONMIGRATION_detailLine: "Line",
    SUBSCRIPTIONMIGRATION_detailBefore: "Before",
    SUBSCRIPTIONMIGRATION_detailAfter: "After",
    SUBSCRIPTIONMIGRATION_detailTotal: "Total",
    SUBSCRIPTIONMIGRATION_included: "Included up to {quantity}"
};
